import React from "react";
import AppIconPage from "./AppIconPage";

const PUBLIC = process.env.PUBLIC_URL || "";
const APP_ICON_2_ART = `${PUBLIC}/ad/word-wheel-quest-app-icon-2-512.png`;

/** Independent copy of the Word Wheel Quest icon for the next design iteration. */
export default function AppIcon2Page() {
    return (
        <AppIconPage
            art={APP_ICON_2_ART}
            fileName="word-wheel-quest-app-icon-2-512x512.png"
            label="App icon #2"
            screenshotFrame="word-wheel-app-icon-2"
        />
    );
}
